import { HarvestTypes, PassOrFail } from "@gtpl/shared-models/common-models"
import { CompanyTypeEnum } from "@gtpl/shared-models/masters"

export class ReweighmentReq{
    grnId:number
    grnItemId:number
    boxes:number
    sampleQty:number
    samplePieces:number
    count:number
    countQtyInfo:CountQtyInfo[]
    createdUser:string
    indentId:number
    reweighmentBillTo:CompanyTypeEnum
    plantId:number
    defectsInfo : DefectsInfo[]
    batchNumber : string
    referenceNumber:number
    addonCount: boolean
    farmer?:number
    farmCode?:number
    broker?:number
    harvestType?: HarvestTypes
    vehilceRequired?: boolean
    userName ?: string
    vehicleNumber?:string
    saleOrderId?:number
    saleOrderItemId?:number
    sealNumber?:string
    reweighmentDate?:Date
    supervisor?:number
    mainBatchNumber?:string
    antiboiticTestResult?:PassOrFail

    constructor(grnId:number,grnItemId:number,boxes:number,sampleQty:number,samplePieces:number,count:number,countQtyInfo:CountQtyInfo[],createdUser:string,indentId:number,reweighmentBillTo:CompanyTypeEnum,plantId:number,defectsInfo : DefectsInfo[],batchNumber : string,referenceNumber:number,addonCount: boolean,farmer?:number,farmCode?:number,broker?:number,harvestType?: HarvestTypes,vehilceRequired?: boolean,userName ?: string,vehicleNumber?:string, saleOrderId?:number,saleOrderItemId?:number,sealNumber?:string,
        reweighmentDate?:Date,
        supervisor?:number,mainBatchNumber?:string,antiboiticTestResult?:PassOrFail){
        this.grnId = grnId
        this.grnItemId = grnItemId
        this.boxes = boxes
        this.sampleQty = sampleQty
        this.samplePieces = samplePieces
        this.count = count
        this.countQtyInfo = countQtyInfo
        this.createdUser = createdUser
        this.indentId = indentId
        this.reweighmentBillTo = reweighmentBillTo
        this.plantId = plantId
        this.defectsInfo = defectsInfo
        this.batchNumber = batchNumber
        this.referenceNumber = referenceNumber
        this.addonCount = addonCount
        this.farmer = farmer
        this.farmCode = farmCode
        this.broker = broker
        this.harvestType = harvestType
        this.userName = userName
        this.vehilceRequired = vehilceRequired
        this.vehicleNumber = vehicleNumber
        this.saleOrderId = saleOrderId
        this.saleOrderItemId = saleOrderItemId
        this.sealNumber=sealNumber
        this.reweighmentDate=reweighmentDate
        this.supervisor=supervisor
        this.mainBatchNumber = mainBatchNumber
        this.antiboiticTestResult = antiboiticTestResult
    }
}

export class CountQtyInfo{
    count:number;
    quantity:number;

    constructor(count:number,quantity:number){
        this.count = count
        this.quantity = quantity
    }
}

export class DefectsInfo{
    defectId : number
    indentItemId : number
    defectPercentage : number
    defectQuantity : number

    constructor(defectId : number,indentItemId : number,defectPercentage : number,defectQuantity : number){
        this.defectId = defectId
        this.indentItemId = indentItemId
        this.defectPercentage = defectPercentage
        this.defectQuantity = defectQuantity
    }
}